import { defaultColorPalette } from '@/constants/brandingThemes';
import { Status } from '@/types/common';
import { Box, Typography } from '@mui/material';

type StatusLabelProps = {
  status: Status;
  isSmall?: boolean;
};

export default function StatusLabel({
  status,
  isSmall = false,
}: StatusLabelProps) {
  const isInactive = status === Status.INACTIVE;
  const statusLabel = isInactive ? 'Inactive' : 'Active';
  const statusColor = isInactive
    ? defaultColorPalette.error
    : defaultColorPalette.success;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}>
      <Box
        sx={{
          backgroundColor: statusColor,
          height: isSmall ? 10 : 13,
          width: isSmall ? 10 : 13,
          borderRadius: '50%',
          marginRight: '5px',
          marginTop: '-3px',
        }}
      />
      <Typography variant={isSmall ? 'caption' : 'body1'}>
        {statusLabel}
      </Typography>
    </Box>
  );
}
